import { Font, Style } from '../constants';
import { createContext } from 'react';

export const AssetsContext = createContext<ContextProps>({
	styles: [],
	fonts: [],
	error: null,
	isLoading: false,
	stylesMap: new Map(),
});

interface ContextProps {
	styles: Array<Style>;
	fonts: Array<Font>;
	error: Error | null;
	isLoading: boolean;
	stylesMap: Map<string, Style>;
}
